import script from "./TagList.vue?vue&type=script&setup=true&lang=js"
export * from "./TagList.vue?vue&type=script&setup=true&lang=js"

import "./TagList.vue?vue&type=style&index=0&id=73b0e254&lang=scss"

const __exports__ = script;

export default __exports__